var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 33,
    viewBox: "0 0 108 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3790_1021)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3790_1021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4945 21.0163C39.5349 36.1676 59.068 36.1676 70.1085 25.4151C80.9057 14.8994 92.8334 6.31177e-06 107.905 7.62939e-06L-0.193021 -1.82086e-06C12.133 -7.43286e-07 20.71 11.4596 28.4945 21.0163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4945 21.0163C39.5349 36.1676 59.068 36.1676 70.1085 25.4151C80.9057 14.8994 92.8334 6.31177e-06 107.905 7.62939e-06L-0.193021 -1.82086e-06C12.133 -7.43286e-07 20.71 11.4596 28.4945 21.0163Z",
    fill: "url(#paint0_linear_3790_1021)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.3668 12.4856L50.4896 17.2882C51.0946 17.8554 52.0846 17.8554 52.6896 17.2882L57.8125 12.4856",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3790_1021",
    x: -14.1934,
    y: -19,
    width: 136.099,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.207843 0 0 0 0 0.447059 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3790_1021"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3790_1021",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3790_1021",
    x1: 51,
    y1: 33,
    x2: 51,
    y2: -5.3036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3790_1021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 33,
    fill: "white",
    transform: "translate(108 33) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewNav);
export default __webpack_public_path__ + "static/media/view-nav.2eb76450ebd2c1bf37e36a12879df924.svg";
export { ForwardRef as ReactComponent };